// Spend & save track: the cart re-renders it on every change, so on connect it
// slides from the last known position to the new one instead of snapping, and
// ticks each milestone on (or off) as the fill actually crosses it.
const STORAGE_KEY = 'cart-tiers-fill';
const DURATION = 900;
const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

if (!customElements.get('cart-tiers-track')) {
    customElements.define('cart-tiers-track', class extends HTMLElement {
        connectedCallback() {
            const fill = this.querySelector('.\\#cart-tiers-track-fill');
            if (!fill) return;

            const target = parseFloat(this.dataset.fill) || 0;
            let prev = NaN;
            try {
                prev = parseFloat(sessionStorage.getItem(STORAGE_KEY));
                sessionStorage.setItem(STORAGE_KEY, target);
            } catch (e) {}

            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (isNaN(prev) || Math.abs(prev - target) < 0.1 || reduceMotion) return;

            // Milestones that change state during this move start in their old state
            const pins = [...this.querySelectorAll('.\\#cart-tiers-pin')]
                .map(pin => ({
                    pin,
                    pos: parseFloat(pin.style.getPropertyValue('--pos')),
                    final: pin.classList.contains('@reached')
                }))
                .filter(p => p.final !== (p.pos <= prev));
            pins.forEach(p => p.pin.classList.toggle('@reached', !p.final));

            fill.style.transition = 'none';
            fill.style.width = prev + '%';
            fill.getBoundingClientRect();
            fill.style.transition = `width ${DURATION}ms ${EASING}`;
            requestAnimationFrame(() => { fill.style.width = target + '%'; });

            if (!pins.length) return;
            const start = performance.now();
            const tick = now => {
                const trackWidth = this.getBoundingClientRect().width || 1;
                const current = fill.getBoundingClientRect().width / trackWidth * 100;
                const done = now - start > DURATION + 100;
                pins.forEach(p => {
                    if (p.settled) return;
                    const crossed = target > prev ? current >= p.pos - 0.5 : current <= p.pos + 0.5;
                    if (crossed || done) {
                        p.settled = true;
                        p.pin.classList.toggle('@reached', p.final);
                        if (p.final) p.pin.classList.add('@pop');
                    }
                });
                if (!done && pins.some(p => !p.settled)) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
        }
    });
}
